import { render, staticRenderFns } from "./CardRoleEggComponent.vue?vue&type=template&id=c1deee4e&scoped=true"
import script from "./CardRoleEggComponent.vue?vue&type=script&lang=js"
export * from "./CardRoleEggComponent.vue?vue&type=script&lang=js"
import style0 from "./CardRoleEggComponent.vue?vue&type=style&index=0&id=c1deee4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1deee4e",
  null
  
)

export default component.exports